import Symbol from "./Symbol";
import { INSPECTOR_ELECTRIC_ENERGY_SUPPLIER } from "../../../constants/inspectorConstants";

// Fuentes de Energía
class ElectricEnergySupplier extends Symbol {
    constructor({ alias, svgSrc, label, rotable, handles, name}) {
        super("ElectricEnergySupplier", { alias, svgSrc, label, rotable, handles, name });

        this.attributes = {
            ...this.attributes,
            ratedVoltage: { isVisible: false, value: null, label: "Voltaje nominal" },
            threePhaseICC: { isVisible: false, value: null, label: "ICC Trifásica" },
            lineToGroundICC: { isVisible: false, value: null, label: "ICC de Línea a Tierra" },
            threePhaseXRZ: { isVisible: false, value: null, label: "X/R o Z Trifásica" },
            lineToGroundXRZ: { isVisible: false, value: null, label: "X/R o Z Línea a Tierra" },
        };                
    }

    getInspector() {
        return INSPECTOR_ELECTRIC_ENERGY_SUPPLIER;
    }
}

export default ElectricEnergySupplier;
